import GearParagraph from "../../ui/gearparagraph";
import GearHeadings from "../../ui/gearheadings";
import GearButton from "../../ui/gearbutton";
import { Avatar } from "../../ui/Gearavatar";
import { User } from "../../types/User";
import { GearPal } from "../../types/Pal";
import { useTranslation } from "react-i18next";
import { useEditProfile } from "../../components/providers/ModalsProvider";
import ProfileContacts from "../../components/ProfileContacts";

interface UserDataProps {
  profile: User;
  gearpalsData: GearPal[];
}

export const UserData: React.FC<UserDataProps> = ({
  profile,
  gearpalsData,
}) => {
  const { t } = useTranslation();
  const { open: openEditProfile } = useEditProfile();
  const windowSize = window.innerWidth;
  const AvatarSize = windowSize < 768 ? 80 : 122;
  const TextSize = windowSize < 768 ? 20 : 30;
  return (
    <div className="relative profile-card">
      <div className="flex items-center gap-6">
        <Avatar
          size={AvatarSize}
          name={profile?.firstName || ""}
          textSize={TextSize}
          surname={profile?.lastName || ""}
        />
        <div className="flex flex-col gap-2">
          <GearHeadings variant="h2" className="text-white capitalize">
            {profile.firstName} {profile.lastName}
          </GearHeadings>
          <GearParagraph variant="medium">
            {t("pages.profile.memberSince", "Membro da")}{" "}
            {new Date(profile.createdAt).toLocaleDateString()}
          </GearParagraph>
          <GearParagraph variant="medium" className="text-secondary">
            {gearpalsData?.length}{" "}
            {t("pages.profile.activeListings", "Elenchi Attivi")}
          </GearParagraph>
          <ProfileContacts contacts={profile.contacts} />
        </div>
      </div>
      <GearButton
        variant="ghost"
        size="small"
        className="absolute top-4 right-4 text-white"
        onClick={openEditProfile}
      >
        <img src="/icons/editblue.svg" alt="edit" />
      </GearButton>
    </div>
  );
};
